// extracted by mini-css-extract-plugin
module.exports = {"Icon":"style_Icon__H9gGD"};